import { ManagedRuntime } from 'effect';

import { CoreEngineLayerClient } from './layers/ClientLayer';
import * as Atom from 'effect/unstable/reactivity/Atom';

const fallbackRuntime = ManagedRuntime.make(CoreEngineLayerClient);

declare global {
  var __clientRuntime: typeof fallbackRuntime | undefined;
}

export const RuntimeClient = globalThis.__clientRuntime ?? fallbackRuntime;

export const RuntimeClientAtom = Atom.runtime(CoreEngineLayerClient);
